import { render, staticRenderFns } from "./master-merchant-list.vue?vue&type=template&id=9bcb7626&scoped=true&"
import script from "./master-merchant-list.vue?vue&type=script&lang=js&"
export * from "./master-merchant-list.vue?vue&type=script&lang=js&"
import style0 from "./master-merchant-list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./master-merchant-list.vue?vue&type=style&index=1&id=9bcb7626&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcb7626",
  null
  
)

export default component.exports